export default {
      id: "x-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.b0d228b5.svg#x-icon",
      toString: function () {
        return this.url;
      }
    }